<template>
  <NewBsBox
    :bs="{ 'cmp.menu.fold': 'default' }"
    class="menu-fold"
  >
    <template
      v-for="(treeNode, idx) in iconList"
      :key="idx + treeNode[idKey]"
    >
      <Divider
        v-if="idx > 0"
        hair-line
        data-style="divider"
      />

      <NewBsBox
        :bs="{display: 'flex', justifyContent: 'left'}"
      >
        <NewBsBox
          :data-active="treeNode[idKey] === activeParentId"
          :bs="getTreeNodeBs(treeNode)"
          class="menu-item"
          @mouseenter="e => handleHover(e, treeNode[idKey])"
          @mouseleave="e => handleHover(e, null)"
        >
          <BeerIcon
            v-if="treeNode.icon && !treeNode.parentId"
            :icon="treeNode.icon"
            :bs="{cursor: 'pointer'}"
            data-style="icon"
          />
        </NewBsBox>
      </NewBsBox>
    </template>
  </NewBsBox>
</template>
<script lang="ts">
  import NewBsBox from '@xhs/yam-beer/cmp/primitive/NewBsBox'
  import BeerIcon from '@xhs/yam-beer/cmp/common/Icon/Icon.vue'
  import Divider from '@xhs/yam-beer/cmp/common/Divider/Divider.vue'
  import { defineComponent, PropType } from 'vue'
  import { nodeType } from '@xhs/yam-beer/utils/transTree'

  export default defineComponent({
    name: 'CollapsedMenuList',
    components: {
      NewBsBox,
      BeerIcon,
      Divider,
    },
    props: {
      /**
       * 处理后扁平话菜单结构
       * id,
       * text
       * groupName,
       * idPat: [...]
       * isLastItem,
       * parentId,
       * hasChild,
       * Expand,
       * visible
       * }]
       */
      menuFlatList: {
        type: Array as PropType<nodeType[]>,
        default: () => ([]),
      },
      /**
       * 菜单节点样式
       */
      getTreeNodeBs: Function,
      /**
       * 传入的list的uniq key
       */
      idKey: {
        type: String,
        default: 'id',
      },
      /**
       * 当前页面菜单Id
       */
      activeId: [String, Number],
      /**
       * primary | success | danger | warning | secondary
       * ！style文件 中使用
       */
      modifier: {
        type: String,
        default: 'primary',
      },
    },
    emits: ['setItemHover'],
    computed: {
      activeParentId(): string | undefined {
        const item: nodeType = this.menuFlatList.find(
          m => m[this.idKey] === this.activeId,
        ) || { idPath: [] }

        return item.parentId
      },
      iconList(): nodeType[] {
        return this.menuFlatList
          .filter(treeNode => !treeNode.parentId)
      },
    },
    methods: {
      handleHover(e: Event, val: string) {
        this.$emit('setItemHover', {
          key: val,
          el: e.target,
        })
      },
    },
  })
</script>
